import { ref } from 'vue';
import { $fetch } from '@/utils/fetch';

export interface ExamSlot {
  /** 考试日期 YYYY-MM-DD */
  date: string;
  /** 时间段，形如 "09:00:00-11:00:00" */
  times: string[];
}

export interface ExamSiteInfo {
  siteId: string;
  name: string;
  location: string;
  capacity: number;
  traffic_info: string;
  contact_info: string;
  slots: ExamSlot[];
}

interface ExamDetailData {
  sites: ExamSiteInfo[];
}

/**
 * 报名弹窗专用：按考试 id 拉取考点与场次。
 * 仅消费 /api/web/exam/get 返回的 sites，考试基本信息沿用列表已传入的 subject。
 */
export function useExamSites() {
  const sites = ref<ExamSiteInfo[]>([]);
  const loading = ref(false);

  async function fetchSites(examId: string) {
    loading.value = true;
    const { isSuccess, data } = await $fetch<ExamDetailData>('/api/web/exam/get', {
      data: { id: examId },
      errorMessage: false,
    });
    loading.value = false;

    if (!isSuccess || !data) {
      sites.value = [];
      return;
    }

    sites.value = data.sites ?? [];
  }

  function reset() {
    sites.value = [];
  }

  return { sites, loading, fetchSites, reset };
}
